@if (errorMessages?.length) {
<div>
  @if (errorMessages?.length === 1) {
  <div>
    <div [className]="promptClassError">
      <div [className]="iconBackgroundError">
        <img src="assets/images/warning.svg" class="error-red" />
      </div>
      <div class="message">{{ errorMessages[0] }}</div>
    </div>
  </div>
  } @if (errorMessages?.length > 1) {
  <div>
    <div [className]="promptClassError" id="multi-messages">
      <div [className]="iconBackgroundError">
        <img src="assets/images/warning.svg" class="error-red" />
      </div>
      <ul class="message multiple-messages">
        @for (msg of errorMessages; track msg) {
        <li>{{ msg }}</li>
        }
      </ul>
    </div>
  </div>
  }
</div>
} @if (warningMessages?.length) {
<div>
  @if (warningMessages?.length === 1) {
  <div>
    <div [className]="promptClassWarning">
      <div [className]="iconBackgroundWarning">
        <img src="assets/images/warning.svg" class="warn-yellow" />
      </div>
      <div class="message">{{ warningMessages[0] }}</div>
    </div>
  </div>
  } @if (warningMessages?.length > 1) {
  <div>
    <div [className]="promptClassWarning" id="multi-messages">
      <div [className]="iconBackgroundWarning">
        <img src="assets/images/warning.svg" class="warn-yellow" />
      </div>
      <ul class="message multiple-messages">
        @for (msg of warningMessages; track msg) {
        <li>{{ msg }}</li>
        }
      </ul>
    </div>
  </div>
  }
</div>
}
